import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BankOnlineGatewayDto, TypeIpGs } from '../../../../core/api/models';
import { GetEnumValuesDto } from '../../../../core/api/models/get-enum-values-dto';
import { RegularExpressions } from '../../../../core/constants/regular-expressions';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { CreateBankOnlineGatewayCommand } from './../../../../core/api/models/create-bank-online-gateway-command';
import { UpdateBankOnlineGatewayCommand } from './../../../../core/api/models/update-bank-online-gateway-command';
import { BankOnlineGatewaysService } from './../../../../core/api/services/bank-online-gateways.service';
import { BankConfig } from './../../../../core/models/bank-config.model';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';

@Component({
    selector: 'app-bank-online-gateways-form',
    templateUrl: './bank-online-gateways-form.component.html',
    imports: [BaseFormModule]
})
export class BankOnlineGatewaysFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  model: CreateBankOnlineGatewayCommand = {};
  formPageConfig: FormPageConfig<BankOnlineGatewayDto> = {};
  protected currentService = inject(BankOnlineGatewaysService);

  //bank config
  public bankConfig: BankConfig = {};
  userNameActive: boolean;
  passwordActive: boolean;
  terminalIdActive: boolean;
  terminalKeyActive: boolean;
  merchantIdActive: boolean;
  shaKeyActive: boolean;
  loginAccountActive: boolean;
  userPasswordActive: boolean;
  merchantCodeActive: boolean;
  privateKeyActive: boolean;
  privateCodeActive: boolean;
  IVActive: boolean;
  keyActive: boolean;
  merchantConfigIdActive: boolean;
  acceptorIdActive: boolean;
  passPhraseActive: boolean;
  publicKeyActive: boolean;

  get TypeIpGs() {
    return TypeIpGs;
  }

  TypeIpGsModel: GetEnumValuesDto[] = [];

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  //#region init

  initModel() {
    try {
      this.model.isActive = false;
      this.model.isFactorUse = false;
      this.model.isGeneralUse = false;

      this.getEnumValuesApi('TypeIPGs')
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((gatWays) => {
          if (!this.formPageConfig.isEditMode) {
            this.showBankConfigSelected(gatWays[0].key);
            // this.model.typeIpg = +gatWays[0].key;
            this.formPageConfig.editData = {};
          } else {
            this.showBankConfigSelected(this.formPageConfig.editData.typeIpg);
            this.model.typeIpg = +this.formPageConfig.editData.typeIpg;
            this.model = Object.assign({}, this.formPageConfig.editData);
            this.bankConfig = JSON.parse(this.model.configJson);
          }
        });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  initForm() {
    this.form = new FormGroup({
      accountInformationId: new FormControl('', Validators.required),
      isActive: new FormControl(Validators.required),
      typeIPG: new FormControl(''),
      isFactorUse: new FormControl(),
      isGeneralUse: new FormControl(),

      //bank
      userName: new FormControl(''),
      password: new FormControl(''),
      userPassword: new FormControl(''),
      merchantId: new FormControl(''),
      terminalKey: new FormControl(''),
      terminalId: new FormControl(''),
      shaKey: new FormControl(''),
      loginAccount: new FormControl(''),
      merchantCode: new FormControl(''),
      privateKey: new FormControl(''),
      privateCode: new FormControl(''),
      IV: new FormControl(''),
      key: new FormControl(''),
      merchantConfigId: new FormControl(''),
      acceptorId: new FormControl(''),
      passPhrase: new FormControl(''),
      publicKey: new FormControl(''),
    });
  }

  //#endregion

  //#region bankConfig for configJson

  showBankConfigSelected(gatWay: TypeIpGs) {
    try {
      ConsoleService.info('gatWay', gatWay);
      this.clearBankConfigValidation();

      switch (gatWay) {
        case TypeIpGs.Melli: {
          this.terminalKeyActive = true;
          this.terminalIdActive = true;
          this.merchantIdActive = true;
          this.setBankConfigValidation('merchantId');
          this.setBankConfigValidation('terminalKey');
          this.setBankConfigValidation('terminalId');
          break;
        }
        case TypeIpGs.AsanPardakht: {
          this.IVActive = true;
          this.keyActive = true;
          this.merchantConfigIdActive = true;
          this.userNameActive = true;
          this.passwordActive = true;
          this.setBankConfigValidation('merchantConfigId');
          this.setBankConfigValidation('key');
          this.setBankConfigValidation('IV');
          this.setBankConfigValidation('userName');
          this.setBankConfigValidation('password');
          break;
        }
        // case "تاپ": {
        //   this.userNameActive = true;
        //   this.setBankConfigValidation("userName");
        //   break;
        // }
        case TypeIpGs.Saman: {
          this.passwordActive = true;
          this.merchantIdActive = true;
          this.setBankConfigValidation('password');
          this.setBankConfigValidation('merchantId');
          break;
        }
        case TypeIpGs.Sepehr: {
          this.terminalIdActive = true;
          this.setBankConfigValidation('terminalId');
          break;
        }
        case TypeIpGs.Mellat: {
          this.terminalIdActive = true;
          this.userNameActive = true;
          this.userPasswordActive = true;
          this.setBankConfigValidation('terminalId');
          this.setBankConfigValidation('userPassword');
          this.setBankConfigValidation('userName');
          break;
        }
        case TypeIpGs.IranKish: {
          // this.merchantIdActive = true;
          // this.shaKeyActive = true;
          // this.setBankConfigValidation("shaKey");
          // this.setBankConfigValidation("merchantId");
          // break;
          this.terminalIdActive = true;
          this.acceptorIdActive = true;
          this.passPhraseActive = true;
          this.publicKeyActive = true;
          this.setBankConfigValidation('terminalId');
          this.setBankConfigValidation('acceptorId');
          this.setBankConfigValidation('passPhrase');
          this.setBankConfigValidation('publicKey');
          break;
        }
        case TypeIpGs.Parsian: {
          this.loginAccountActive = true;
          this.setBankConfigValidation('loginAccount');
          break;
        }
        case TypeIpGs.ZarinPal: {
          this.merchantIdActive = true;
          this.setBankConfigValidation('merchantId');
          break;
        }
        case TypeIpGs.Pasargad: {
          this.merchantCodeActive = true;
          this.privateKeyActive = true;
          this.privateCodeActive = true;
          this.setBankConfigValidation('privateCode');
          this.setBankConfigValidation('privateKey');
          this.setBankConfigValidation('merchantCode');
          break;
        }
      }

      this.updateBankConfigValidation();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  setBankConfigValidation(fieldName) {
    try {
      this.form
        .get(fieldName)
        .setValidators([
          Validators.required,
          Validators.pattern(RegularExpressions.englishCharacters),
        ]);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  clearBankConfigValidation() {
    try {
      this.form.get('userName').clearValidators();
      this.form.get('password').clearValidators();
      this.form.get('userPassword').clearValidators();
      this.form.get('merchantId').clearValidators();
      this.form.get('terminalKey').clearValidators();
      this.form.get('terminalId').clearValidators();
      this.form.get('shaKey').clearValidators();
      this.form.get('loginAccount').clearValidators();
      this.form.get('merchantCode').clearValidators();
      this.form.get('privateKey').clearValidators();
      this.form.get('privateCode').clearValidators();
      this.form.get('IV').clearValidators();
      this.form.get('key').clearValidators();
      this.form.get('merchantConfigId').clearValidators();

      this.userNameActive = false;
      this.passwordActive = false;
      this.userPasswordActive = false;
      this.terminalKeyActive = false;
      this.terminalIdActive = false;
      this.merchantIdActive = false;
      this.shaKeyActive = false;
      this.loginAccountActive = false;
      this.merchantCodeActive = false;
      this.privateCodeActive = false;
      this.privateKeyActive = false;
      this.IVActive = false;
      this.keyActive = false;
      this.merchantConfigIdActive = false;

      this.bankConfig = {};
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }

  updateBankConfigValidation() {
    try {
      this.form.get('userName').updateValueAndValidity();
      this.form.get('password').updateValueAndValidity();
      this.form.get('userPassword').updateValueAndValidity();
      this.form.get('merchantId').updateValueAndValidity();
      this.form.get('terminalKey').updateValueAndValidity();
      this.form.get('terminalId').updateValueAndValidity();
      this.form.get('shaKey').updateValueAndValidity();
      this.form.get('loginAccount').updateValueAndValidity();
      this.form.get('merchantCode').updateValueAndValidity();
      this.form.get('privateKey').updateValueAndValidity();
      this.form.get('privateCode').updateValueAndValidity();
      this.form.get('IV').updateValueAndValidity();
      this.form.get('key').updateValueAndValidity();
      this.form.get('merchantConfigId').updateValueAndValidity();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }
  //#endregion

  //#region Api

  //Create
  baseCreateApi(model: CreateBankOnlineGatewayCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .bankOnlineGatewaysCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: UpdateBankOnlineGatewayCommand) {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .bankOnlineGatewaysUpdatePut({
        id: this.formPageConfig.editId,
        body: model,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  onSubmit() {
    try {
      if (!this.isValidForm(this.form, this.tagName)) return;
      if (this.loading) return;
      this.model.configJson = JSON.stringify(this.bankConfig);
      this.checkCreateOrUpdate();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.financial);
    }
  }
}
